// Auto-generated per-query builders for AttributeValue
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { AttributeValueReadAPI, AttributeValueWriteAPI, AttributeValueReadAPISchema, AttributeValueWriteAPISchema } from '../types/attributevalue';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, AttributeValueHasUnitOverride, AttributeValueOfAttribute, HasAttributeValue } from '../../relationships/relationship';

import { Attribute } from './attribute';
import { Unit } from './unit';
import { RFLPElement } from './rflpelement';
import { SecurityScope } from '../../shared/api/securityscope';





// Builder chain for query: rflp-attribute-value-by-id

export interface RflpAttributeValueByIdBuilder_0 {
  get(id: string): RflpAttributeValueByIdBuilder_1;
  filter(conditions: { id: string }): RflpAttributeValueByIdBuilder_1;
}

export interface RflpAttributeValueByIdBuilder_1 {
  all(): Promise<AttributeValue[]>;
  first(): Promise<AttributeValue | null>;
  get(): Promise<AttributeValue[]>;
  execute(): Promise<AttributeValue[]>;
}


// Union of all query entry points
export type AttributeValueQueryBuilder = RflpAttributeValueByIdBuilder_0;

// Available query names for .setQuery()
export type AttributeValueQueryNames = "rflp-attribute-value-by-id";

// Type narrowing for .setQuery()
export type AttributeValueBuilderForQuery<Q extends AttributeValueQueryNames> =
  Q extends "rflp-attribute-value-by-id" ? RflpAttributeValueByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type AttributeValueInstanceQueryResult<Q extends AttributeValueQueryNames> =
  Q extends "rflp-attribute-value-by-id" ? RflpAttributeValueByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-attribute-value-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends AttributeValueQueryNames>(queryName: Q): AttributeValueBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface AttributeValue extends Partial<AttributeValueReadAPI> {}
export class AttributeValue extends NeoNodeBase<AttributeValueReadAPI, AttributeValueWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "AttributeValue";
  static readonly readSchema = AttributeValueReadAPISchema;
  static readonly writeSchema = AttributeValueWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attribute: { target: "Attribute", cardinality: "one", isParent: true, relClass: "AttributeValueOfAttribute", direction: "out" },
    unit_override: { target: "Unit", cardinality: "one", isParent: false, relClass: "AttributeValueHasUnitOverride", direction: "out" },
    owner: { target: "RFLPElement", cardinality: "one", isParent: true, relClass: "HasAttributeValue", direction: "in" },
  };

  protected get modelName(): string {
    return 'AttributeValue';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return AttributeValue.label;
  }


  constructor(data: Partial<AttributeValueWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: AttributeValueReadAPI, loadContext?: Record<string, any>): AttributeValue {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { attribute, unit_override, owner, security_scope, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = AttributeValueReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, attribute: attribute, unit_override: unit_override, owner: owner, security_scope: security_scope };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return AttributeValue.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'attribute', 'Attribute', ModelRegistry);
    loadOneRelationship(processed, 'unit_override', 'Unit', ModelRegistry);
    loadManyRelationship(processed, 'owner', 'RFLPElement', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new AttributeValue(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): AttributeValueQueryBuilder {
    return new QueryBuilderImpl('AttributeValue').filter(conditions) as any;
  }

  static all(): AttributeValueQueryBuilder {
    return new QueryBuilderImpl('AttributeValue') as any;
  }

  static async first(): Promise<AttributeValue | null> {
    const results = await new QueryBuilderImpl('AttributeValue').execute();
    return results[0] || null;
  }


  static setQuery<Q extends AttributeValueQueryNames>(queryName: Q): AttributeValueBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('AttributeValue');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends AttributeValueQueryNames>(queryName: Q): AttributeValueInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = AttributeValue.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const attributevalue = await AttributeValue.get(id).first();
   * await attributevalue.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await attributevalue.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'attribute' - Python ORM style (cached)
  get attribute(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attribute', () => {
      return new RelationshipManager(this, 'attribute', 'one', AttributeValueOfAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'unit_override' - Python ORM style (cached)
  get unit_override(): RelationshipManager<this, Unit> {
    return this.getOrCreateRelationshipManager('unit_override', () => {
      return new RelationshipManager(this, 'unit_override', 'one', AttributeValueHasUnitOverride as typeof Relationship);
    });
  }

  // Relationship manager for 'owner' - Python ORM style (cached)
  get owner(): RelationshipManager<this, RFLPElement> {
    return this.getOrCreateRelationshipManager('owner', () => {
      return new RelationshipManager(this, 'owner', 'one', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

}
